export const numberCurrencyFormat = () => {

    const options = { style: 'currency', currency: 'COP' };

    const numberFormat = new Intl.NumberFormat('es-CO', options);
    
    return numberFormat
}
